module.exports = __webpack_public_path__ + "img/digital-illustrations.7a6f6272.png";